export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10140.f65d357e.jpg";